import { gtcDebounce } from "gtcUtils";
import { fetchPredictiveResults, fetchProductResults } from "clerkUtils";

class ClerkPredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.apiKey = window.theme.settings.clerkApiKey;
    if (!this.apiKey) {
      return;
    }

    this.dom = {
      input: this.querySelector("#search-desktop"),
      headerSearchBar: document.querySelector("input.header-search-bar"),
    };

    this.addEventListeners();
  }

  buildProductResults(productCards) {
    return `
      <div class="predictive-search__row">
        <p class="search-drawer__title predictive-search__title">Products</p>

        <style data-shopify="">
          .predictive-search__grid {
            column-gap: var(--grid-spacing);
          }
        </style>

        <div class="predictive-search__grid">
          ${productCards.map((card) => card.outerHTML).join("")}
        </div>
      </div>
    `;
  }

  renderProductResults(productCards) {
    const container = this.querySelector(".predictive-search__col-product");

    if (!container) {
      console.warn("Container .predictive-search__col-product not found");
      return;
    }

    const parser = new DOMParser();

    const productResults = this.buildProductResults(productCards);

    const html = parser.parseFromString(productResults, "text/html");
    const elements = Array.from(html.body.children);

    container.replaceChildren(...elements)

    Clerk("click", "*[data-clerk-product-id]");
  }

  // buildSuggestion() {
  //   return `
  //   <li class="predictive-search__links-item">
  //     <a href="{{- query.url -}}" class="predictive-search__links-link">
  //       <span aria-label="{{ query.text }}">{{ query.styled_text }}</span>
  //     </a>
  //   </li>`;
  // }

  // buildSuggestions(suggestions) {

  // }

  // buildCollection(collection) {
  //   return `
  //     <li class="predictive-search__links-item">
  //       <a href="${collection.url}">
  //         <div class="predictive-search__collections-img">
  //           <div class="media">
  //             <img src="${collection.image}&amp;width=128" alt="${collection.name}">
  //           </div>    
  //         </div>
  //         <div class="predictive-search__collections-title">
  //           <span>${collection.name}</span>
  //         </div>
  //       </a>
  //     </li>
  //   `;
  // }

  // buildCollections(response) {
  //   if (!response.categories) {
  //     return; 
  //   }

  //   const collectionHtml = response.categories.map((collection) => this.buildCollection(collection));

  //   const parser = new DOMParser();

  //   const elements = collectionHtml.map((text) => {
  //     const newNode = parser.parseFromString(text, "text/html");
  //     const productElements = Array.from(newNode.body.children)[0];

  //     return productElements;
  //   });

  //   const container = this.querySelector("[data-collections]");
  //   container.replaceChildren(...elements);
  // }

  // fetchCollectionResults = (query, callback) => {
  //   const options = { method: "GET", headers: { accept: "application/json" } };

  //   fetch(
  //     ` https://api.clerk.io/v2/search/categories?query=${query}&limit=3&key=${window.theme.settings.clerkApiKey}`,
  //     options
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       callback(res);
  //     })
  //     .catch((err) => console.error(err));
  // };

  // fetchSuggestionsResults = (query, callback) => {
  //   const options = { method: "GET", headers: { accept: "application/json" } };

  //   fetch(
  //     ` https://api.clerk.io/v2/search/suggestions?query=${query}&limit=3&key=${window.theme.settings.clerkApiKey}`,
  //     options
  //   )
  //     .then((res) => res.json())
  //     .then((res) => {
  //       callback(res);
  //     })
  //     .catch((err) => console.error(err));
  // };

  search(query) {
    fetchPredictiveResults(query, (urls) => {
      const params = {
        urls: urls,
        view: "clerk-item",
        callback: (elements) => this.renderProductResults(elements),
      };

      fetchProductResults(params);
    });

    //this.fetchCollectionResults(query, (collections) => this.buildCollections(collections));
    //fetchSuggestionsResults(query, (collections) => buildSuggestions(collections));
  }

  addEventListeners() {
    this.dom.input.addEventListener(
      "input",
      gtcDebounce((event) => {
        this.search(event.target.value);
        this.dom.headerSearchBar.value = event.target.value;
      }, 300)
    );

    this.dom.headerSearchBar.addEventListener("focus", () =>
      document.dispatchEvent(new Event("open-search"))
    );
  }
}

if (!customElements.get("clerk-predictive-search")) {
  customElements.define("clerk-predictive-search", ClerkPredictiveSearch);
}
